import {
  CustomizeUAPPlacementType as CPT,
  CustomizePlacementMetaList,
} from './customize-ad-placements';

import ImageAdWithCtaLarge from '../../media/image-ad-with-cta-large.jpg';
import ImageAdWithCtaSmall from '../../media/image-ad-with-cta-small.jpg';
import ImageAdWithLogo from '../../media/image-ad-with-logo.jpg';
import ImageAdWithRating11 from '../../media/image-ad-with-rating-11.jpg';
import ImageAdWithRating134 from '../../media/image-ad-with-rating-134.jpg';
import ImageAdWithVideo from '../../media/image-ad-with-video.jpg';
import ImageAdBackground from '../../media/image-ad-with-image-as-background.jpg';
import LogoImage from '../../media/logo-image.png';

export const getCustomizeAdPlacementList = (i18n, displayMode) => ([
  {
    placementMeta: {
      ...CustomizePlacementMetaList[CPT.ImageAdPlacementWithCTA],
      aspectRatio: 1.64,
    },
    imageMeta: {
      url: ImageAdWithCtaSmall,
      originalWidth: 339,
      originalHeight: 207,
    },
    dataMapping: {
      shortHeadline: i18n.getString(_TL_('Contoso', { locked: true, comment: 'fixed name' })),
      longHeadline: i18n.getString(_TL_('Elevate Your Game')),
      callToAction: i18n.getString(_TL_('Learn more')),
      imagePreviewHeight: 207,
    },
  },
  {
    placementMeta:
      CustomizePlacementMetaList[CPT.ImageAdWithLogoPlacementNoImage],
    logoImageMeta: {
      url: LogoImage,
      originalWidth: 114,
      originalHeight: 114,
    },
    dataMapping: {
      shortHeadline: i18n.getString(_TL_('Contoso', { locked: true, comment: 'fixed name' })),
      finalUrl: '.',
      displayUrl: 'www.contoso.com',
      ratingPoint: 4.3,
      ratingComment: i18n.getString(_TL_('(199K)')),
      description: i18n.getString(_TL_('Transform your everyday into a journey.')),
      callToAction: i18n.getString(_TL_('Download from Play Store')),
      logoImagePreviewHeight: 80,
    },
  },
  {
    placementMeta: CustomizePlacementMetaList[CPT.ImageAdPlacementWithRating],
    imageMeta: {
      url: ImageAdWithRating11,
      originalWidth: 300,
      originalHeight: 167,
    },
    dataMapping: {
      shortHeadline: i18n.getString(_TL_('Contoso', { locked: true, comment: 'fixed name' })),
      longHeadline: i18n.getString(_TL_('Velocity Vibe Skateboard')),
      ratingPoint: 5,
      ratingComment: i18n.getString(_TL_('11')),
      description: i18n.getString(_TL_('$50.00')),
      imagePreviewHeight: 167,
    },
  },
  {
    placementMeta:
      CustomizePlacementMetaList[CPT.ImageAdPlacementWithImageAsBackground],
    imageMeta: {
      url: ImageAdBackground,
      originalWidth: displayMode === 's' ? 360 : 438,
      originalHeight: displayMode === 's' ? 201 : 245,
    },
    dataMapping: {
      shortHeadline: i18n.getString(_TL_('Contoso', { locked: true, comment: 'fixed name' })),
      longHeadline: i18n.getString(_TL_('Blossom in Style | Valentine\'s day special')),
      imagePreviewHeight: displayMode === 's' ? 201 : 245,
    },
  },
  {
    placementMeta: CustomizePlacementMetaList[CPT.TextAdPlacement],
    dataMapping: {
      longHeadline: i18n.getString(_TL_('Home Bliss Essentials | Your One-Stop Shop for Modern Living')),
      finalUrl: '.',
      displayUrl: 'www.contoso.com/fruit/coupon',
      businessName: i18n.getString(_TL_('Order Now And Get Same Day Delivery!')),
      locationText: i18n.getString(_TL_('1234 Street Address, City · 0.0 mi')),
      ratingPoint: 4.3,
      ratingComment: i18n.getString(_TL_('(199K reviews)')),
      callToAction: i18n.getString(_TL_('Browse')),
    },
  },
  {
    placementMeta: CustomizePlacementMetaList[CPT.ImageAdPlacementWithPlayIcon],
    imageMeta: {
      url: ImageAdWithVideo,
      originalWidth: displayMode === 's' ? 360 : 438,
      originalHeight: displayMode === 's' ? 201 : 246,
    },
    dataMapping: {
      imagePreviewHeight: displayMode === 's' ? 201 : 245,
    },
  },
  {
    placementMeta: CustomizePlacementMetaList[CPT.ImageAdPlacementWithCTA],
    imageMeta: {
      url: ImageAdWithCtaLarge,
      originalWidth: displayMode === 's' ? 360 : 438,
      originalHeight: displayMode === 's' ? 252 : 307,
    },
    dataMapping: {
      shortHeadline: i18n.getString(_TL_('Contoso', { locked: true, comment: 'fixed name' })),
      longHeadline: i18n.getString(_TL_('Short headline')),
      callToAction: i18n.getString(_TL_('Learn more')),
      imagePreviewHeight: displayMode === 's' ? 252 : 307,
    },
  },
  {
    placementMeta: CustomizePlacementMetaList[CPT.ImageAdPlacementWithRating],
    imageMeta: {
      url: ImageAdWithRating134,
      originalWidth: 300,
      originalHeight: 167,
    },
    dataMapping: {
      shortHeadline: i18n.getString(_TL_('Contoso Fashion', { locked: true, comment: 'fixed name' })),
      longHeadline: i18n.getString(_TL_('CloudCush Comfort Pillow')),
      description: i18n.getString(_TL_('$65.00')),
      ratingPoint: 5,
      ratingComment: i18n.getString(_TL_('134')),
      imagePreviewHeight: 167,
    },
  },
  {
    placementMeta:
      CustomizePlacementMetaList[CPT.ImageAdWithLogoPlacementWithImage],
    imageMeta: {
      url: ImageAdWithLogo,
      originalWidth: 184,
      originalHeight: 127,
    },
    logoImageMeta: {
      url: LogoImage,
      originalWidth: 20,
      originalHeight: 20,
    },
    dataMapping: {
      shortHeadline: i18n.getString(_TL_('Contoso Hotel', { locked: true, comment: 'fixed name' })),
      longHeadline: i18n.getString(_TL_('Cozy Retreat Room')),
      priceText: i18n.getString(_TL_('$€ Price $206')),
      locationText: i18n.getString(_TL_('Redmond')),
      description: i18n.getString(_TL_('Discover unbeatable value with...')),
      callToAction: i18n.getString(_TL_('Book Now')),
      imagePreviewHeight: 127,
      logoImagePreviewHeight: 20,
    },
  },
  {
    placementMeta: CustomizePlacementMetaList[CPT.TextAdPlacement],
    dataMapping: {
      longHeadline: i18n.getString(_TL_('Edible Arrangements | Save On Fruit Bouquets and Baskets')),
      finalUrl: '.',
      displayUrl: 'www.contoso.com/fruit/coupon',
      businessName: i18n.getString(_TL_('Order Now And Get Same Day Delivery!')),
      locationText: i18n.getString(_TL_('1234 Street Address, City · 0.0 mi')),
      ratingPoint: 4.3,
      ratingComment: i18n.getString(_TL_('(199K reviews)')),
      callToAction: i18n.getString(_TL_('Browse')),
    },
  },
]);
